var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 42.65C23.5333 42.65 23.0667 42.5667 22.6 42.4C22.1333 42.2333 21.7167 41.9833 21.35 41.65C19.1833 39.65 17.2667 37.7 15.6 35.8C13.9333 33.9 12.5417 32.0583 11.425 30.275C10.3083 28.4917 9.45833 26.775 8.875 25.125C8.29167 23.475 8 21.9 8 20.4C8 15.4 9.60833 11.4167 12.825 8.45C16.0417 5.48333 19.7667 4 24 4C28.2333 4 31.9583 5.48333 35.175 8.45C38.3917 11.4167 40 15.4 40 20.4C40 21.9 39.7083 23.475 39.125 25.125C38.5417 26.775 37.6917 28.4917 36.575 30.275C35.4583 32.0583 34.0667 33.9 32.4 35.8C30.7333 37.7 28.8167 39.65 26.65 41.65C26.2833 41.9833 25.8667 42.2333 25.4 42.4C24.9333 42.5667 24.4667 42.65 24 42.65ZM24 24C25.1 24 26.0417 23.6083 26.825 22.825C27.6083 22.0417 28 21.1 28 20C28 18.9 27.6083 17.9583 26.825 17.175C26.0417 16.3917 25.1 16 24 16C22.9 16 21.9583 16.3917 21.175 17.175C20.3917 17.9583 20 18.9 20 20C20 21.1 20.3917 22.0417 21.175 22.825C21.9583 23.6083 22.9 24 24 24Z",
    fill: "#0C2856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.5634405c2f28316319243a6b4c203cc9.svg";
export { ForwardRef as ReactComponent };